import { render } from "./Browser.vue?vue&type=template&id=417d18e9&bindings={}"
import script from "./Browser.vue?vue&type=script&lang=ts"
export * from "./Browser.vue?vue&type=script&lang=ts"
script.render = render

export default script